module.exports = __webpack_public_path__ + "media/img/covers/header-cover-7259dc23b16a289d01ec0b22750705d4.jpg";